import { Navbar } from "react-bootstrap";
import flareLogo from "../images/flare-symbol-black.png";

export default function Footer() {
  return (
    <>
      <Navbar
        fixed="bottom"
        bg="white"
        variant="light"
        className="footer"
        style={{ height: "50px", whiteSpace: "nowrap" }}
      >
        <span style={{ marginLeft: "5%" }}>
          <img src={flareLogo} style={{ width: "1em" }} alt="Flare Logo"></img>{" "}
          Spark
          <b>
            <a
              href="/"
              style={{
                textDecoration: "none",
                fontSize: "10px",
                color: "gray",
                marginLeft: "10%",
              }}
            >
              © Spark Energy 2023{" "}
            </a>{" "}
          </b>{" "}
          {/* <span style={{ paddingLeft: "1em", paddingRight: "1em" }}> | </span> */}
          {/* <b>founders@flare.com</b> */}
        </span>
      </Navbar>
    </>
  );
}
